// external dependencies
import React from 'react'
import styled from '@emotion/styled'

const Strong = styled.span`
	font-weight: bold;
`

export default {
	strong: props => <Strong {...props} />,
}
